module.exports = __webpack_public_path__ + "static/media/20.f1332857.jpg";